// extracted by mini-css-extract-plugin
export var arrow = "_32-6";
export var changeItem = "_32-3";
export var changesHeader = "_32-1";
export var changesList = "_32-2";
export var container = "_32-0";
export var pathLabel = "_32-4";
export var value = "_32-7";
export var valuesContainer = "_32-5";